var myDropzone, myDropzone2;

Dropzone.autoDiscover = false;

var checkfor = document.getElementById("media-uploader"), checkedfor = true;
if ( (typeof checkfor === 'undefined') || (checkfor === null) ) {
    checkedfor = false;
}


if (checkedfor) {

    myDropzone = new Dropzone("#media-uploader", {
        url: dropParam.upload,
        acceptedFiles: '.jpg,.jpeg,.pdf,.doc,.xls,.docx,.xlsx,.png',
        maxFiles: 1,
        uploadMultiple: false,
        maxFilesize: 20, // 20 MB
        success: function (file, response) {
            file.previewElement.classList.add("dz-success");
            file.attachment_id = response; // push the id for future reference
            if (jQuery('#school_policy_upload').length > 0){
                jQuery('#school_policy_upload').val(response);
            }
            if (jQuery('#child_care_plan_upload').length > 0){
                jQuery('#child_care_plan_upload').val(response);
            }
            if (jQuery('#lesson_plan_media_resource_upload').length > 0){
                jQuery('#lesson_plan_media_resource_upload').val(response);
            }

        },
        error: function (file, response) {
            file.previewElement.classList.add("dz-error");
        },
        // update the following section is for removing image from library
        addRemoveLinks: true,
        removedfile: function (file) {
            if (jQuery('#school_policy_upload').length > 0){
                jQuery('#school_policy_upload').val();
            }
            if (jQuery('#child_upload_care_plan').length > 0){
                jQuery('#child_upload_care_plan').val();
            }
            if (jQuery('#lesson_plan_media_resource_upload').length > 0){
                jQuery('#lesson_plan_media_resource_upload').val();
            }
            var attachment_id = file.attachment_id;
            jQuery.ajax({
                type: 'POST',
                url: dropParam.delete,
                data: {
                    media_id: attachment_id
                }
            });
            var _ref;
            return (_ref = file.previewElement) !== null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
        }
    });

}

var checkfor2 = document.getElementById("media-uploader2"), checkedfor2 = true;
if ( (typeof checkfor2 === 'undefined') || (checkfor2 === null) ) {
    checkedfor2 = false;
}


if (checkedfor2) {

    myDropzone2 = new Dropzone("#media-uploader2", {
        url: dropParam.upload,
        acceptedFiles: '.jpg,.jpeg,.pdf,.doc,.xls,.docx,.xlsx,.png',
        maxFiles: 1,
        uploadMultiple: false,
        maxFilesize: 20, // 20 MB
        success: function (file, response) {
            file.previewElement.classList.add("dz-success");
            file.attachment_id = response; // push the id for future reference
            if (jQuery('#featured_image_upload').length > 0){
                jQuery('#featured_image_upload').val(response);
            }
        },
        error: function (file, response) {
            file.previewElement.classList.add("dz-error");
        },
        // update the following section is for removing image from library
        addRemoveLinks: true,
        removedfile: function (file) {
            if (jQuery('#featured_image_upload').length > 0){
                jQuery('#featured_image_upload').val();
            }
            var attachment_id = file.attachment_id;
            jQuery.ajax({
                type: 'POST',
                url: dropParam.delete,
                data: {
                    media_id: attachment_id
                }
            });
            var _ref;
            return (_ref = file.previewElement) !== null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
        }
    });

}


function flip_form(selector) {
    jQuery('#' + selector + '-form').hide();
    jQuery('#' + selector + '-data').show();
    jQuery('#' + selector).show();
    jQuery('#' + selector + '-submit').html('Save');
}


jQuery('body').on('submit', '.ajax-form', function(event) {
    event.preventDefault();

    //alert('posted');

    var form_id     = jQuery(this).attr('id');
    var selector    = form_id.replace("-form","");
    var form_data   = jQuery(this).serialize() + "&action=hc_update" + "&selector=" + selector;

    //console.log(form_id);
    //console.log(selector);
    //console.log(form_data);

    //alert('check console');

    jQuery.ajax({

        type: 'POST',

        url: theme_ajax.url,

        data: form_data,

        success: function(data, textStatus, XMLHttpRequest) {

            var update = jQuery.parseJSON(data);

            var selector = update.selector;
            delete(update.selector);

            //console.log(data);
            //console.log(update);
            //console.log(selector);

            if (selector === 'school-policies') {

                jQuery('#school_policies_and_documents_data').html(update.school_policies_no_edit);
                jQuery('#school_policies_and_documents_form').html(update.school_policies_can_edit);
                jQuery('#school_policy_name_choices').val('');
                jQuery('#school_policy_name').val('');
                jQuery('#school_policy_format1').prop('checked', false);
                jQuery('#school_policy_format2').prop('checked', false);
                jQuery('#school_policy_format3').prop('checked', false);
                jQuery('#school_policy_paste').val('');
                jQuery('#school_policy_upload').val('');
                jQuery('#school_policy_link').val('');

                jQuery('.school-policy-format-file').css('display','none');

                myDropzone.files[0].attachment_id = "";
                myDropzone.removeAllFiles();
                flip_form(selector);

            } else if (selector === 'featured-image') {

                jQuery('#featured_image').attr('src',update.featured_image);
                myDropzone2.files[0].attachment_id = "";
                myDropzone2.removeAllFiles();
                flip_form(selector);


            } else if (selector === 'school-policies-orig') {

                jQuery('#school_policies_and_documents_data').html(update.school_policies_no_edit);
                jQuery('#school_policies_and_documents_form').html(update.school_policies_can_edit);

            //} else if (selector === 'class-details') {

               // jQuery('#school_classes').html(update.classes_can_edit);

            } else if (selector === 'child-details') {

                jQuery.each(update, function (index, value) {
                    jQuery('#' + index + '_data').html(value);
                });


				var send = '';
				if (jQuery.isArray(update.child_category_of_special_need)) {
					jQuery.each(update.child_category_of_special_need, function(index, value) {
						if (value === 'speech') { send += 'Speech and Language, '; }
						if (value === 'sensory') { send += 'Sensory, '; }
						if (value === 'physical') { send += 'Physical, '; }
						if (value === 'behavioural') { send += 'Behavioural, '; }
						if (value === 'cognitive') { send += 'Cognitive, '; }
						if (value === 'other') { send += 'Other, '; }
					});
					if (send !== '') {
						send = send.slice(0,-2);
						jQuery('#child_category_of_special_need_data').html(send);
					}
				}

                jQuery('.child_participation').hide();

                if (jQuery.inArray('medical',update.child_participation_information) !== -1) {
                    jQuery('#child_medical_row').show();
                    jQuery('#child_files_row').show();
                }
                if (jQuery.inArray('eal',update.child_participation_information) !== -1) {
                    jQuery('#child_eal_row').show();
                    jQuery('#child_files_row').show();
                }
                if (jQuery.inArray('premium',update.child_participation_information) !== -1) {
                    jQuery('#child_premium_row').show();
                    jQuery('#child_files_row').show();
                }
                if (jQuery.inArray('send',update.child_participation_information) !== -1) {
                    jQuery('#child_send_row').show();
                    jQuery('#child_send2_row').show();
                    jQuery('#child_files_row').show();
                }
                if (jQuery.inArray('other',update.child_participation_information) !== -1) {
                    jQuery('#child_other_row').show();
                    jQuery('#child_files_row').show();
                }

                var media_consent = '';
                if (update.child_media_consent === 'Yes') {

                    media_consent = "<span class='media-yes'>";
                    media_consent += "<span class='media-yes'>";
                    media_consent += "<span class='glyphicon glyphicon-camera'></span> ";
                    media_consent += "<strong>Ok To Photograph</strong>";
                    media_consent += "</span>";
                    media_consent += "</span>";

                } else {

                    media_consent = "<span class='media-no'>";
                    media_consent += "<span class='media-no'>";
                    media_consent += "<span class='glyphicon glyphicon-camera'></span> ";
                    media_consent += "<strong>No Photography</strong>";
                    media_consent += "</span>";
                    media_consent += "</span>";
                }

                jQuery('#media_consent').html(media_consent);

                jQuery('#child_care_plan_data').html(update.child_care_plan_no_edit);
                jQuery('#child_care_plan_form').html(update.child_care_plan_can_edit);
                jQuery('#child_care_plan_name_choices').val('');
                jQuery('#child_care_plan_name').val('');
                jQuery('#child_care_plan_format1').prop('checked', false);
                jQuery('#child_care_plan_format2').prop('checked', false);
                jQuery('#child_care_plan_format3').prop('checked', false);
                jQuery('#child_care_plan_paste').val('');
                jQuery('#child_care_plan_upload').val('');
                jQuery('#child_care_plan_link').val('');

                jQuery('.child-care-plan-format-file').css('display','none');

                if (jQuery.isArray(myDropzone.files)) {
                    if (jQuery.isArray(myDropzone.files[0])) {
                        myDropzone.files[0].attachment_id = "";
                        myDropzone.removeAllFiles();
                    }
                }
                flip_form(selector);

            } else if (selector === 'unit-details') {

                window.location.href = '/class/' + update.redirect + '/#view_curriculum';

            } else if (selector === 'mtp-details') {

                window.location.href = '/mtp/' + update.redirect + '/';

            }else if (selector === 'mtp-pupils') {

                  window.location.href = '/mtp/' + update.redirect + '/';

            } else if (selector === 'lesson-plan-schedule-details') {

                window.location.href = '/mtp/' + update.redirect + '/';

            } else if (selector === 'lesson-plan-details') {

                if (update.lesson_plan_edit_media === "1") {

                    window.location.href = '/edit/lesson-plan-media/' + update.redirect + '/';

                } else {

                    window.location.href = '/lesson-plan/' + update.redirect + '/';

                }

            } else if (selector === 'lesson-plan-media') {

                window.location.href = '/edit/lesson-plan-media/' + update.redirect + '/';

            } else {

                jQuery.each(update, function (index, value) {

                    if (index === "title") {
                        jQuery('#' + index + '_data').html(value);
                        jQuery('#' + index + '_copy_data').html(value);
                    } else if (index === "school_email_address") {
                        jQuery('#' + index + '_data').html(value).attr('href', 'mailto:' + value);
                    } else if (index === "school_website") {
                        jQuery('#' + index + '_data').html(value).attr('href', value);
                    } else {
                        jQuery('#' + index + '_data').html(value);
                    }
                    flip_form(selector);

                    //alert( index + ": " + value );
                });

            }

        },

        error: function(MLHttpRequest, textStatus, errorThrown) {
            console.log(MLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
            alert('Error, please contact support.');
        }

    });

});



jQuery('body').on('submit', '.ajax-form-add', function(event) {
    event.preventDefault();

    var form_id     = jQuery(this).attr('id');
    var selector    = form_id.replace("-form","");
    var form_data   = jQuery(this).serialize() + "&action=hc_add" + "&selector=" + selector;

    //console.log(form_id);
    //console.log(selector);
    //console.log(form_data);


    jQuery.ajax({

        type: 'POST',

        url: theme_ajax.url,

        data: form_data,

        success: function(data, textStatus, XMLHttpRequest) {

            var update = jQuery.parseJSON(data);

            var selector = update.selector;
            delete(update.selector);

            //console.log(data);
            //console.log(update);
            //console.log(selector);


            if (selector === 'class-details') {

                jQuery('#school_classes-data').html(update.classes_can_edit);
                jQuery('#school_classes-form').html(update.classes_form);

                jQuery('#' + selector + '-form').hide();

            } else if (selector === 'child-details') {

                jQuery('#class-children').html(update.child_list);

                jQuery('#' + selector + '-form').hide();

            } else if (selector === 'unit-details') {

                window.location.href = '/class/' + update.redirect + '/#view_curriculum';

            } else if (selector === 'mtp-details') {

                window.location.href = '/mtp/' + update.redirect + '/';

            } else if (selector === 'lesson-plan-schedule-details') {

                window.location.hfer = '/mtp/' + update.redirect + '/';

            } else {

                jQuery.each(update, function (index, value) {

                    if (index === "title") {
                        jQuery('#' + index + '_data').html(value);
                        jQuery('#' + index + '_copy_data').html(value);
                    } else if (index === "school_email_address") {
                        jQuery('#' + index + '_data').html(value).attr('href', 'mailto:' + value);
                    } else if (index === "school_website") {
                        jQuery('#' + index + '_data').html(value).attr('href', value);
                    } else {
                        jQuery('#' + index + '_data').html(value);
                    }

                    jQuery('#' + selector + '-form').hide();
                    //alert( index + ": " + value );
                });

            }





            /*var update = jQuery.parseJSON(data);

            var selector = update.selector;
            delete(update.selector);

            //console.log(data);
            //console.log(update);
            //console.log(selector);

            if (selector === 'school-policies') {

                jQuery('#school_policies_and_documents_data').html(update.school_policies_no_edit);
                jQuery('#school_policies_and_documents_form').html(update.school_policies_can_edit);
                jQuery('#school_policy_name_choices').val('');
                jQuery('#school_policy_name').val('');
                jQuery('#school_policy_format1').prop('checked', false);
                jQuery('#school_policy_format2').prop('checked', false);
                jQuery('#school_policy_format3').prop('checked', false);
                jQuery('#school_policy_paste').val('');
                jQuery('#school_policy_upload').val('');
                jQuery('#school_policy_link').val('');
                myDropzone.removeAllFiles();

            } else if (selector === 'school-policies-orig') {

                jQuery('#school_policies_and_documents_data').html(update.school_policies_no_edit);
                jQuery('#school_policies_and_documents_form').html(update.school_policies_can_edit);

            } else {

                jQuery.each(update, function (index, value) {

                    if (index === "title") {
                        jQuery('#' + index + '_data').html(value);
                        jQuery('#' + index + '_copy_data').html(value);
                    } else if (index === "school_email_address") {
                        jQuery('#' + index + '_data').html(value).attr('href', 'mailto:' + value);
                    } else if (index === "school_website") {
                        jQuery('#' + index + '_data').html(value).attr('href', value);
                    } else {
                        jQuery('#' + index + '_data').html(value);
                    }
                    //alert( index + ": " + value );
                });

            }

            if (selector !== 'school-policies-orig') {
                jQuery('#' + selector + '-form').hide();
                jQuery('#' + selector + '-data').show();
                jQuery('#' + selector).show();
                jQuery('#' + selector + '-submit').html('Save');
            }*/

        },

        error: function(MLHttpRequest, textStatus, errorThrown) {
            console.log(MLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
            alert('Error, please contact support.');
        }

    });

});








jQuery('body').on('submit', '.ajax-form-existing', function(event) {
    event.preventDefault();

    var form_id     = jQuery(this).attr('id');
    var selector    = form_id.replace("-form","");
    var form_data   = jQuery(this).serialize() + "&action=hc_existing" + "&selector=" + selector;

    //console.log(form_id);
    //console.log(selector);
    //console.log(form_data);


    jQuery.ajax({

        type: 'POST',

        url: theme_ajax.url,

        data: form_data,

        success: function(data, textStatus, XMLHttpRequest) {

            var update = jQuery.parseJSON(data);

            var selector = update.selector;
            delete(update.selector);

            //console.log(data);
            //console.log(update);
            //console.log(selector);

            jQuery('#class-children').html(update.child_list);

            jQuery('#' + selector + '-form').hide();

        },

        error: function(MLHttpRequest, textStatus, errorThrown) {
            console.log(MLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
            alert('Error, please contact support.');
        }

    });

});










jQuery(function() {
    jQuery(document).on('click', '.btn-add-new', function (e) {
        e.preventDefault();
        var selector = jQuery(this).data('selector') + "-form";
        jQuery('#'+selector).show();

    });
});

jQuery(function() {
    jQuery(document).on('click', '.btn-add-existing', function (e) {
        e.preventDefault();

        var selector = jQuery(this).data('selector') + "-form";
        jQuery('#'+selector).show();

    });
});


jQuery(function() {
    jQuery(document).on('click', '.btn-add', function(e) {
        e.preventDefault();

        var selector = jQuery(this).data('selector');
        var controlForm = jQuery('#'+selector+' div:first');
        var currentEntry = jQuery('#'+selector+' .entry:first');
        var newEntry = currentEntry.clone();
        controlForm.append(newEntry);
        newEntry.find('input[type="text"]').val('');
        newEntry.find('select').val('');
        newEntry.find('input[type="checkbox"]').prop('checked', false);
        newEntry.find('textarea').val('');
        var randid = jQuery.now();
        newEntry.find('.lesson_plan_activity_id').val(randid);
        newEntry.find('.lesson_plan_activity_title').attr('data-randid',randid);

    }).on('click', '.btn-remove', function(e) {

        var selector = jQuery(this).data('selector');
        var controlForm = jQuery('#'+selector+' div:first');
        var currentEntry = jQuery(this).parents('.entry:first');
        var newEntry = currentEntry.clone();
        var count = jQuery('#'+selector+' div:first .entry').size();

        jQuery(this).parents('.entry:first').remove();
        if (count === 1) {
            controlForm.append(newEntry);
            newEntry.find('input[type="text"]').val('');
            newEntry.find('select').val('');
            newEntry.find('input[type="checkbox"]').prop('checked', false);
            newEntry.find('textarea').val('');
        }

        e.preventDefault();
        return false;
    });
});



jQuery(function() {
    jQuery(document).on('click', '.docremove', function(e) {
        if (confirm('This will remove the document, are you sure?')) {

            var repeaterid = jQuery(this).data('repeater'),
                repeaterlabel = jQuery(this).data('label'),
                schoolid = jQuery(this).data('schoolid'),
                fileid = jQuery(this).data('file');

            if (repeaterid !== "") {

                var ajaxdata = {repeater_id:repeaterid, repeater_label:repeaterlabel, school_id:schoolid};

                if (fileid !== "") {
                    ajaxdata.media_id = fileid;
                }

                jQuery('#repeater' + repeaterid).animate({height: 0, opacity: 0}, 'fast', function () {
                    jQuery('#repeater' + repeaterid).remove();
                });

                jQuery('#repeater_' + repeaterid).animate({height: 0, opacity: 0}, 'fast', function () {
                    jQuery('#repeater_' + repeaterid).remove();
                });

                /*console.log(ajaxdata);*/

                jQuery.ajax({
                    type: 'POST',
                    url: dropParam.remove,
                    data: ajaxdata
                }).done(function() {
                    jQuery('#school-policies-orig-form').submit();
                });

            }

        }
    });
});


jQuery(function() {
    jQuery(document).on('click', '.careplanremove', function(e) {
        if (confirm('This will remove the document, are you sure?')) {

            var repeaterid = jQuery(this).data('repeater'),
                repeaterlabel = jQuery(this).data('label'),
                childid = jQuery(this).data('childid'),
                fileid = jQuery(this).data('file');

            if (repeaterid !== "") {

                var ajaxdata = {repeater_id:repeaterid, repeater_label:repeaterlabel, child_id:childid};

                if (fileid !== "") {
                    ajaxdata.media_id = fileid;
                }

                jQuery('#repeater' + repeaterid).animate({height: 0, opacity: 0}, 'fast', function () {
                    jQuery('#repeater' + repeaterid).remove();
                });

                jQuery('#repeater_' + repeaterid).animate({height: 0, opacity: 0}, 'fast', function () {
                    jQuery('#repeater_' + repeaterid).remove();
                });

                /*console.log(ajaxdata);*/

                if (fileid !== "") {
                    jQuery.ajax({
                        type: 'POST',
                        url: dropParam.remove,
                        data: ajaxdata
                    }).done(function () {

                    });
                }

                ajaxdata.action = "hc_removeplan";


                jQuery.ajax({
                    type: 'POST',
                    url: theme_ajax.url,
                    data: ajaxdata
                }).done(function () {

                });

            }

        }
    });
});


jQuery(function() {
    jQuery(document).on('click', '.lessonplanmediaremove', function(e) {
        if (confirm('This will remove the media item, are you sure?')) {

            var repeaterid = jQuery(this).data('repeater'),
                repeaterlabel = jQuery(this).data('label'),
                lpid = jQuery(this).data('lpid'),
                fileid = jQuery(this).data('file');

            if (repeaterid !== "") {

                var ajaxdata = {repeater_id:repeaterid, repeater_label:repeaterlabel, lpid:lpid};

                if (fileid !== "") {
                    ajaxdata.media_id = fileid;
                }

                jQuery('#repeater' + repeaterid).animate({height: 0, opacity: 0}, 'fast', function () {
                    jQuery('#repeater' + repeaterid).remove();
                });

                jQuery('#repeater_' + repeaterid).animate({height: 0, opacity: 0}, 'fast', function () {
                    jQuery('#repeater_' + repeaterid).remove();
                });

                /*console.log(ajaxdata);*/

                if (fileid !== "") {
                    jQuery.ajax({
                        type: 'POST',
                        url: dropParam.remove,
                        data: ajaxdata
                    }).done(function () {

                    });
                }

                ajaxdata.action = "hc_removelessonplanmedia";


                jQuery.ajax({
                    type: 'POST',
                    url: theme_ajax.url,
                    data: ajaxdata
                }).done(function () {

                });

            }

        }
    });
});




jQuery(function() {
    jQuery(document).on('click', '.classremove', function(e) {
        if (confirm('This will remove the class, are you sure?')) {

            var classid = jQuery(this).data('classid');

            if (classid !== "") {

                var ajaxdata = "action=class_remove&classid="+classid;

                jQuery('#class' + classid).animate({height: 0, opacity: 0}, 'fast', function () {
                    jQuery('#class' + classid).remove();
                });

                /*console.log(ajaxdata);*/

                jQuery.ajax({
                    type: 'POST',
                    url: theme_ajax.url,
                    data: ajaxdata
                }).done(function() {

                });

            }

        }
    });
});


jQuery(function() {
    jQuery(document).on('click', '.unitremove', function(e) {
        if (confirm('This will remove the unit of work, are you sure?')) {

            var unitid = jQuery(this).data('unitid');

            if (unitid !== "") {

                var ajaxdata = "action=unit_remove&unitid="+unitid;

                jQuery('#unit_' + unitid).animate({height: 0, opacity: 0}, 'fast', function () {
                    jQuery('#unit_' + unitid).remove();
                });

                /*console.log(ajaxdata);*/

                jQuery.ajax({
                    type: 'POST',
                    url: theme_ajax.url,
                    data: ajaxdata
                }).done(function() {

                });

            }

        }
    });
});


function filter_years(keystage) {

    jQuery('#class_year').css('display','block');
    jQuery('.class_years').css('display','none');
    jQuery('#class_year_13').css('display','block');

    if (keystage === 0) {
        jQuery('#class_year_0').css('display','block');
        jQuery('#class_year_1').css('display','block');
    }

    if (keystage === 1) {
        jQuery('#class_year_2').css('display','block');
        jQuery('#class_year_3').css('display','block');
    }

    if (keystage === 2) {
        jQuery('#class_year_4').css('display','block');
        jQuery('#class_year_5').css('display','block');
        jQuery('#class_year_6').css('display','block');
        jQuery('#class_year_7').css('display','block');
    }

    if (keystage === 3) {
        jQuery('#class_year_8').css('display','block');
        jQuery('#class_year_9').css('display','block');
        jQuery('#class_year_10').css('display','block');
    }

    if (keystage === 4) {
        jQuery('#class_year_11').css('display','block');
        jQuery('#class_year_12').css('display','block');
    }

}

jQuery(function() {
    jQuery(document).on('click', '.class_key_stage', function() {
        var keystage = jQuery(this).data('keystage');
        filter_years(keystage);
    });
});


function check_care_plan_shown() {

    if (
        (jQuery('#child_participation_information_0').is(':checked')) ||
        (jQuery('#child_participation_information_1').is(':checked')) ||
        (jQuery('#child_participation_information_2').is(':checked')) ||
        (jQuery('#child_participation_information_3').is(':checked')) ||
        (jQuery('#child_participation_information_4').is(':checked'))
    ) {
        jQuery('#child-care-plan-fields').css('display','block');
        return;
    }

    jQuery('#child-care-plan-fields').css('display','none');

    return;
}

if (cf === true) {

    check_care_plan_shown();


    if (jQuery('#child_participation_information_0').is(':checked')) {
        jQuery('#medical_field').css('display','block');
    }
    jQuery(document).on('click', '#child_participation_information_0', function(e) {
        if (jQuery('#child_participation_information_0').is(':checked')) {
            jQuery('#medical_field').css('display','block');
            check_care_plan_shown();
        } else {
            jQuery('#medical_field').css('display','none');
            check_care_plan_shown();
        }
    });

    if (jQuery('#child_participation_information_1').is(':checked')) {
        jQuery('#eal_field').css('display','block');

    }
    jQuery(document).on('click', '#child_participation_information_1', function(e) {
        if (jQuery('#child_participation_information_1').is(':checked')) {
            jQuery('#eal_field').css('display','block');
            check_care_plan_shown();
        } else {
            jQuery('#eal_field').css('display','none');
            check_care_plan_shown();
        }
    });

    jQuery(document).on('click', '#child_participation_information_2', function(e) {
        if (jQuery('#child_participation_information_2').is(':checked')) {
            check_care_plan_shown();
        } else {
            check_care_plan_shown();
        }
    });


    if (jQuery('#child_participation_information_3').is(':checked')) {
        jQuery('#send_field_0').css('display','block');
        jQuery('#send_field_1').css('display','block');
        jQuery('#send_field_2').css('display','block');
    }
    jQuery(document).on('click', '#child_participation_information_3', function(e) {
        if (jQuery('#child_participation_information_3').is(':checked')) {
            jQuery('#send_field_0').css('display','block');
            jQuery('#send_field_1').css('display','block');
            jQuery('#send_field_2').css('display','block');
            check_care_plan_shown();
        } else {
            jQuery('#send_field_0').css('display','none');
            jQuery('#send_field_1').css('display','none');
            jQuery('#send_field_2').css('display','none');
            check_care_plan_shown();
        }
    });

    if (jQuery('#child_participation_information_4').is(':checked')) {
        jQuery('#other_field').css('display','block');
    }
    jQuery(document).on('click', '#child_participation_information_4', function(e) {
        if (jQuery('#child_participation_information_4').is(':checked')) {
            jQuery('#other_field').css('display','block');
            check_care_plan_shown();
        } else {
            jQuery('#other_field').css('display','none');
            check_care_plan_shown();
        }
    });

    jQuery(document).on('change', '.child-care-plan-format', function(e) {
        var chosen = jQuery(this).data('child-care-plan-format-choice');
        jQuery('.child-care-plan-format-text').css('display','none');
        jQuery('.child-care-plan-format-file').css('display','none');
        jQuery('.child-care-plan-format-url').css('display','none');
        jQuery('.child-care-plan-format-' + chosen).css('display','block');
    });

}



var mtp_types = ['thinking','doing','feeling'];
jQuery.each(mtp_types, function(index, item) {
    jQuery(function () {
        jQuery(document).on('click', '.expectation_'+item, function (e) {
            var output = '';
            var row = jQuery(this).data('expectation-row');

            if (this.checked){
                jQuery('#intention_'+row).show();
            } else {
                jQuery('#intention_'+row).hide();
            }


            jQuery('.expectation_'+item).each(function () {
                if (this.checked) {
                    output += jQuery(this).data('description') + '\r\n';
                    jQuery(this).parent().addClass('checked');
                } else {
                    jQuery(this).parent().removeClass('checked');
                }
            });
            jQuery('#mtp_'+item+'_success_criteria').html(output);
        });
    });
});

jQuery.each(mtp_types, function(index, item) {
    jQuery(function () {
        jQuery(document).on('click', '.intention_'+item, function (e) {
            var output = '';
            var outputbox = jQuery(this).data('outputbox');

            var clickgroup = jQuery(this).data('clickgroup');
            var clickid = jQuery(this).data('clickid');

            if (this.checked) {
                output += jQuery(this).data('description') + '\r\n';
                jQuery(this).parent().addClass('checked');
                jQuery('#'+outputbox).html(output);
                jQuery('#'+outputbox).css('display','block');

                jQuery('.intention_'+clickgroup).each(function() {
                    console.log('testing' + jQuery(this).data('clickid'));
                    if (jQuery(this).data('clickid') === clickid) {
                        jQuery(this).prop('checked', true);
                    } else {
                        jQuery(this).prop('checked', false);
                        jQuery(this).parent().removeClass('checked');
                    }
                });

            } else {
                jQuery(this).parent().removeClass('checked');
                jQuery('#'+outputbox).css('display','none');
            }

            /*jQuery('.intention_'+item).each(function () {

                if (this.checked) {
                    output += jQuery(this).data('description') + '\r\n';
                    jQuery(this).parent().addClass('checked');
                    jQuery('#'+outputbox).html(output);
                } else {
                    jQuery(this).parent().removeClass('checked');
                }
            });*/


        });
    });
});

jQuery(function () {
    jQuery(document).ready(function () {
        jQuery.each(mtp_types, function(index, item) {
            jQuery('.intention_'+item).each(function () {
                var output ='', outputbox;
                outputbox = jQuery(this).data('outputbox');
                if (this.checked) {
                    output += jQuery(this).data('description') + '\r\n';
                    jQuery(this).parent().addClass('checked');
                    jQuery('#'+outputbox).show().css('display','block').html(output);
                }
            });
        });

    });
});

jQuery(function () {
    jQuery(document).on('click', '.available', function (e) {

        if (jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
        } else {
            jQuery(this).addClass('active');
        }

        // now do the form bit
        var dates = '';

        jQuery.each(jQuery('.active'), function(index, item) {
            var date = jQuery(this).data('date');
            dates += date + ",";
        });

        if (dates !== '') {
            dates = dates.slice(0,-1);
        }

        jQuery('#lesson_plan_schedule_dates').val(dates);

    });
});

/*window.onload = function() {
    jQuery('textarea').each(
        function(index){
            var input = jQuery(this).html();
            var regex = /&lt;br \/&gt;/gi;
            jQuery(this).html(input.replace(regex, ""));
        }
    );
};*/

/*function populate_activities() {
    // count activities
    var obj = [];
    jQuery(".activity_title").each(function (index, element) {
        var title = jQuery(this).val();
        var randid = jQuery(this).attr('data-randid');
        var temp = {};
        temp[randid] = title;
        obj.push(temp);
    });

    var selectstring = '<option value="">Choose Activity</option>';

    jQuery.each(obj, function (key, value) {
        jQuery.each(value, function (randid, title) {
            if (title === "") { title = '<- no name ->'; }
            selectstring += '<option value="' + randid + '">' + title + '</option>';
        });
    });

    jQuery('#lesson_plan_media_resource_activity').html(selectstring);

}*/


/*
if (pa === true) {

    /*jQuery(document).on('click', '.btn-add', function (e) {
        setTimeout(populate_activities, 200);
    });
    jQuery(document).on('click', '.btn-remove', function (e) {
        setTimeout(populate_activities, 200);
    });*//*

}*/



jQuery(function() {
    jQuery(document).on('change', '.lesson-plan-media-resource-format', function(e) {
        var chosen = jQuery(this).data('lesson-plan-media-resource-format-choice');
        jQuery('.lesson-plan-media-resource-format-text').css('display','none');
        jQuery('.lesson-plan-media-resource-format-file').css('display','none');
        jQuery('.lesson-plan-media-resource-format-url').css('display','none');
        jQuery('.lesson-plan-media-resource-format-' + chosen).css('display','block');
        jQuery('.lesson-plan-media-resource-activity').css('display','block');
        //populate_activities();
    });
});

jQuery(function() {
    jQuery(document).on('change', '.school-policy-name-choice', function(e) {
        var chosen = jQuery(this).val();
        if (chosen === "Other") {
            jQuery('.school-policy-name-choice-reveal').css('display','block');
        } else {
            jQuery('.school-policy-name-choice-reveal').css('display','none');
        }
    });
});

jQuery(function() {
    jQuery(document).on('change', '.school-policy-format', function(e) {
        var chosen = jQuery(this).data('school-policy-format-choice');
        jQuery('.school-policy-format-text').css('display','none');
        jQuery('.school-policy-format-file').css('display','none');
        jQuery('.school-policy-format-url').css('display','none');
        jQuery('.school-policy-format-' + chosen).css('display','block');
    });
});



if(jQuery('.fixedOnScroll').length > 0){
  var fixmeTop = jQuery('.fixedOnScroll').offset().top;

  jQuery(window).scroll(function () {
      var currentScroll = jQuery(window).scrollTop(); // get current position


      if (currentScroll > (jQuery('body').height() - jQuery(window).scrollTop())) {
          jQuery('.fixedOnScroll').css({
              height: '80vh'
          });
      }
      if (currentScroll >= fixmeTop) {           // apply position: fixed if you
          jQuery('.fixedOnScroll').css({                      // scroll to that element or below it
              position: 'fixed',
              top: '0'
          });
      } else {                                   // apply position: static
          jQuery('.fixedOnScroll').css({                      // if you scroll above it
              position: 'static'
          });
      }

  });
}

jQuery('.single-child .success-criteria-buttons .btn').click(function () {
    if (!jQuery(this).hasClass('previous')) {

        jQuery(this).parent().find('.btn').removeClass('active');
        jQuery(this).addClass('active');
        jQuery(this).parent().parent().find('.scoreID').val(jQuery(this).attr('data-value'));

    }
});

/*jQuery('#addEvaulation').submit(function (evt) {
    evt.preventDefault();
    jQuery('#eval-submit').html('<i class="fa fa-refresh fa-spin"></i> Saving...');
    jQuery.ajax({url: "/app/themes/honeycomb/lib/ajax.php", data: jQuery('#addEvaulation').serialize()})
        .success(function (e) {
            //console.log(e);
            self.location = '/mtp/'+window.mtpSlug+'/';
        });
});*/


/* Add-Evaluation.php */
jQuery('#addEvaulation .success-criteria-buttons .btn').click(function () {
    jQuery(this).parent().find('.btn').removeClass('active');
    jQuery(this).addClass('active');
    jQuery(this).parent().parent().find('.updateGrade').val(jQuery(this).attr('data-value'));
});

jQuery('#addEvaulation').submit(function (evt) {
    evt.preventDefault();
    jQuery('#eval-submit').html('<i class="fa fa-refresh fa-spin"></i> Saving...');
    jQuery.ajax({url: "/app/themes/honeycomb/lib/ajax.php", data: jQuery('#addEvaulation').serialize()})
        .success(function (e) {
            //console.log(e);
            self.location = '/mtp/'+window.mtpSlug+'/';
        });
});

/* End Add-Evaluation.php */


/* Child-Display.php */
jQuery('.single-child .success-criteria-buttons .btn').click(function () {
    if (!jQuery(this).hasClass('previous')) {
        jQuery(this).parent().find('.btn').removeClass('active');
        jQuery(this).addClass('active');
        jQuery(this).parent().parent().find('#currentTarget').val(jQuery(this).attr('data-value'));
        jQuery(this).parent().parent().find('textarea').removeClass('hidden');
        jQuery(this).parent().parent().find('.form-group').removeClass('hidden');
    }
});

jQuery('.single-child #summativeForm').submit(function (evt) {
    evt.preventDefault();
    jQuery('#saveSummative').html('<i class="fa fa-refresh fa-spin"></i> Saving...');
    jQuery.ajax({url: "/app/themes/honeycomb/lib/ajax.php", data: jQuery('#summativeForm').serialize()})
        .success(function (e) {
            //console.log(e);
            window.location.href = window.location.href;
            //self.location = '/mtp/<?php echo $mtpSlug; ?>/';
        });
});

/* End Child-Display.php */

/* MTP-Display.php */
if(jQuery('body').hasClass('single-mtp') || jQuery('body').hasClass('single-child')){
  window.startFrom = 10;
  window.endValue  = 20;
  window.ajaxInProgess = false;
  window.anyMore = true;
  jQuery(window).scroll(function() {
     if(jQuery(window).scrollTop() + jQuery(window).height() === jQuery(document).height()) {
       if(!window.ajaxInProgess){
         if(window.anyMore){
           jQuery('.assessment_loading').removeClass('hidden');
           window.ajaxInProgess = true;
           jQuery.ajax({url: window.location.href, data: {ajaxRequest:true, start: window.startFrom, end: window.endValue}, method: 'POST'})
           .success(function(e){
             window.startFrom += 10;
             window.endValue += 10;
             window.ajaxInProgess = false;
             var ccunt = jQuery('.assessment_holder .row').length;
             jQuery('.assessment_holder').append(e);
             jQuery('.assessment_loading').addClass('hidden');
             if(e === ""){ window.anyMore = false; }
             if(ccunt === jQuery('.assessment_holder .row').length){ window.anyMore = false; }
           });
         }
       }
     }
  });
}
/* End MTP-Display.php */


/* Add-Evidence.php */
jQuery('.evidencePage #addCommentForm').submit(function (evt) {
    evt.preventDefault();
    jQuery('.evidencePage #addComment').html('<i class="fa fa-refresh fa-spin"></i> Saving...');
    jQuery.ajax({url: "/app/themes/honeycomb/lib/ajax.php", data: jQuery('#addCommentForm').serialize()})
        .success(function (e) {
            //console.log(e);
            self.location = '/mtp/'+window.mtpSlug+'/';
        });
});

jQuery('.evidencePage #addMediaForm').submit(function (evt) {
    evt.preventDefault();
    jQuery('.evidencePage #addMedia').html('<i class="fa fa-refresh fa-spin"></i> Saving...');
    jQuery.ajax({url: "/app/themes/honeycomb/lib/ajax.php", data: jQuery('#addMediaForm').serialize()})
        .success(function (e) {
            //console.log(e);
            self.location = '/mtp/'+window.mtpSlug+'/';
        });
});

jQuery('.evidencePage #mediaLearners').change(function(){
    if(jQuery('#mediaLearners').val() !== "") {
        jQuery('.learners').append('<div class="learner"><h3>' + jQuery('.evidencePage #mediaLearners').find(':selected').text() + '<a href="javascript:void(0);" onClick="removeEvidenceItem(this);" class="pull-right"><i class="fa fa-times"></i></a></h3><textarea rows="3" class="form-control" name="child[' + jQuery('.evidencePage #mediaLearners').val() + ']"></textarea></div>');
        jQuery('#mediaLearners').val('');
    }
});

function removeEvidenceItem(element){
    jQuery(element).parent().parent().remove();
}

jQuery('.evidencePage .success-criteria-buttons .btn').click(function () {
    jQuery(this).parent().find('.btn').removeClass('active');
    jQuery(this).addClass('active');
    jQuery(this).parent().parent().find('.updateGrade').val(jQuery(this).attr('data-value'));
});
/* End Add-Evidence.php */
